import { AspectRatio, Image, Skeleton } from '@mantine/core'
import { BasicPlayer } from './api'
import classes from './Players.module.css'
import { useState } from 'react'
import { Typography } from '../common/typography'

export default function PlayerCard({ player }: { player: BasicPlayer }) {
  const [playerImageLoaded, setPlayerImageLoaded] = useState<boolean>(false)
  const [teamImageLoaded, setTeamImageLoaded] = useState<boolean>(false)
  const isPlaceholderPhoto = /\.svg$/i.test(player.photo.main)

  return (
    <div className={classes.player_card_container}>
      <AspectRatio ratio={1 / 1} className={classes.aspect_ratio}>
        {!playerImageLoaded && <Skeleton circle height="100%" />}

        <Image
          src={player.photo.main}
          alt={player.name}
          className={classes.player_image}
          onLoad={() => setPlayerImageLoaded(true)}
          data-loaded={playerImageLoaded}
          fit={isPlaceholderPhoto ? 'contain' : 'scale-down'}
        />

        <AspectRatio ratio={1 / 1} className={classes.team_logo_container}>
          {!teamImageLoaded && <Skeleton circle height="100%" />}
          <Image
            src={player.team_logo.thumbnail}
            alt={player.name}
            className={classes.team_logo}
            onLoad={() => setTeamImageLoaded(true)}
            data-loaded={teamImageLoaded}
            fit="scale-down"
          />
        </AspectRatio>
      </AspectRatio>
      <Typography level={3} fs="sm" ta="center">
        {player.name}
      </Typography>
    </div>
  )
}
